// frontend/src/hooks/useDeviceProvisioning.js
import React, { useState, useCallback } from 'react';
import AddDeviceModal from '../components/AddDeviceModal';

export function useDeviceProvisioning(onSuccess) {
  const [selectedPlotForDevice, setSelectedPlotForDevice] = useState(null);
  const [isAddDeviceModalOpen, setIsAddDeviceModalOpen] = useState(false);

  const openAddDeviceModal = useCallback((plot) => {
    setSelectedPlotForDevice(plot);
    setIsAddDeviceModalOpen(true);
  }, []);

  const closeAddDeviceModal = useCallback(() => {
    setIsAddDeviceModalOpen(false);
    setSelectedPlotForDevice(null);
  }, []);

  const handleDeviceProvisioned = useCallback(
    async (payload) => {
      console.log('Device provisioned via hook:', payload);
      if (onSuccess) {
        await onSuccess(payload);
      }
      closeAddDeviceModal();
    },
    [onSuccess, closeAddDeviceModal]
  );

  // Helper component to keep JSX clean in pages
  const DeviceProvisioningModal = useCallback(() => (
    <AddDeviceModal
      isOpen={isAddDeviceModalOpen}
      onClose={closeAddDeviceModal}
      plot={selectedPlotForDevice}
      plotSize={selectedPlotForDevice?.size || 'small'}
      onDeviceProvisioned={handleDeviceProvisioned}
    />
  ), [isAddDeviceModalOpen, selectedPlotForDevice, closeAddDeviceModal, handleDeviceProvisioned]);

  return {
    openAddDeviceModal,
    closeAddDeviceModal,
    DeviceProvisioningModal
  };
}
